export const languageCodeMap: { [code: string]: string } = {
  en: "English",
  es: "Spanish",
  hi: "Hindi",
};
